import { formatMoney, formatDate } from '../utils/formatters';

function getOrderKey(order) {
  return `${order.server || 'unknown'}:${order.entityId}`;
}

const HistoryList = ({ orders, selectedOrderId, onSelectOrder }) => {
  if (!orders || orders.length === 0) {
    return <p className="empty-state">No orders found.</p>;
  }

  return (
    <section className="history-list">
      {orders.map(order => (
        <button
          key={getOrderKey(order)}
          type="button"
          className={selectedOrderId === getOrderKey(order) ? 'history-list-item active' : 'history-list-item'}
          onClick={() => onSelectOrder(order)}
        >
          <div className="history-list-item-top">
            <strong>Order #{order.id}</strong>
            <span>{formatMoney(order.total, order.currency)}</span>
          </div>
          <div className="history-list-item-meta">
            <span>{formatDate(order.createdAt)}</span>
            <span>{order.status}</span>
            <span>{order.totalItemCount} item(s)</span>
          </div>
          {order.shippingDescription && (
            <div className="history-list-item-ship">{order.shippingDescription}</div>
          )}
        </button>
      ))}
    </section>
  );
};

export default HistoryList;
